import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import {SessionClient} from '../../client/session';
import {PoolClient} from '../../client/pool';
import {TicketClient} from '../../client/ticket';
import {OfferClient} from '../../client/offer';
import {SyndicateClient} from '../../client/syndicate';
import {ManagerClient} from '../../client/manager';
import {TokenClient} from '../../client/token';
import {GiveawayClient} from '../../client/giveaway';
import {ReservedTicketsClient} from '../../client/reserved_tickets';
import {API_DATA, API_DATA_TOKEN, ImageClient} from '../../client/image';
import {UserClient} from '../../client/user';
import {SyndicatePortionClient} from '../../client/syndicate_portions';
import {FxRatesClient} from '../../client/fx_rates';
import {SettingsClient} from '../../client/settings';
import {TrackingClient} from "../../client/tracking";
import {CampaignsClient} from "../../client/campaigns";
import {CommentaryClient} from "../../client/commentary";
import {FantasyStatsExternalClient} from "../../client/fantasy-stats-external";
import {SportEventsClient} from '../../client/sport_events';

export * from './http.service';
export * from './auth.interceptor';
export * from './identity.service';
export * from '../../client/session';
export * from '../../client/pool';
export * from '../../client/ticket';
export * from '../../client/offer';
export * from '../../client/syndicate';
export * from '../../client/manager';
export * from '../../client/token';
export * from '../../client/giveaway';
export * from '../../client/reserved_tickets';
export * from '../../client/image';
export * from '../../client/user';
export * from '../../client/fx_rates';
export * from '../../client/settings';
export * from '../../client/campaigns';
export * from '../../client/commentary'
export * from "../../client/fantasy-stats-external";
export * from '../../client/sport_events';

export function provideClient(): EnvironmentProviders {
  return makeEnvironmentProviders([
    SessionClient,
    PoolClient,
    TicketClient,
    OfferClient,
    SyndicateClient,
    ManagerClient,
    TokenClient,
    GiveawayClient,
    ReservedTicketsClient,
    ImageClient,
    UserClient,
    SyndicatePortionClient,
    FxRatesClient,
    SettingsClient,
    TrackingClient,
    CampaignsClient,
    CommentaryClient,
    FantasyStatsExternalClient,
    SportEventsClient,
    { provide: API_DATA_TOKEN, useValue: API_DATA }
  ]);
}
